import globalDataReducer from './reducers'
export { default as globalDataActionTypes } from './types'
export { default as globalDataActions } from './actions'
export default globalDataReducer
